import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import session from "./auth/session";
import adminList from "./users/getAdmin";
import general from "./common/general";
import nav from "./nav";
import userProfile, { callGetUserProfileDetail } from "./accounts/users";
import courses from "./course/getCourses";
import usersdetails from "./userdetail";
import courseCategories from "./course/getCourseCategory";
import adminCourseDashboard from "./course/adminDashboard";
import courseDetail from "./course/getCourseDetails";
import courseDiscussions from "./course/forum/getCourseDiscussions";
import courseDiscussion from "./course/forum/getCourseDiscussion";
import courseFAQsList from "./course/faqs/getCourseFAQs";
import courseReviews from "./course/reviews/getCourseReviews";
import learnerCourseReviews from "./course/reviews/getAllLearnerCourseReview";
import fileRepo from "./course/postFileRepo";
import adminCourseModule from "./course/adminCourseModule";
import adminCourseFaq from "./course/adminCourseFaq";
import threads from "./course/forum/getCourseThreads";
import arCourses from "./arvr/getARCourses";
import vrCourses from "./arvr/getVRCourses";
import mrCourses from "./arvr/getMRCourses";
import organizationList from "./organization/getOrganization";
import assignUserList from "./course/getAssignCourses";
import LocationList from "./location/getLocation";
import PathList from "./learningpath/getfilepath";
import errorReducer from "./error";
import error, * as errorSelector from "./error";
import success from "./successReducer";
import learnerCourseReviewReducer from "./learningpath/postLearnerCourseReview";
import learnerCourse from "./course/getLearnerCourseDetail";
import courseModule from "./course/getModuleByCourse";
import watchedVideos from "./course/postFilePercentage";
import notificationReducer from "./notifications/notificationBadge";
import assignReducer from "./assignReducer/assignReducer";
import eventReducer from "./eventReducer/eventInstantReducer";
import cateReducer from "./cateReducer/cateReducer";
import lastCourseStateReducer from "./course/lastCourseState";
import classrooms from "./classrooms/getClasses";
import topics from "./classrooms/getClassRoomTopics";
import sessions from "./classrooms/getTopicSessions";
import classroomDashboard from "./classrooms/classroomDashboard";
import editClassroomSession from "./classrooms/editClassroomSession";
import calendarDashBoard from "./classrooms/calendarDashBoard";
import additionalDashBoard from "./classrooms/additionalDashBoard";
import uuidThemeReducer from "./urlGenerator/urlReducer";
// social wall routes
import auth from "../components/socialWall/reducers/auth";
import local from "../components/socialWall/reducers/local";
import proctor from "./proctor/proctor";
import selectedAssessment from "./proctor/selectedAssessment";
import proctoringUsers from "./proctor/proctoringUsers";
import {
  userListReducer,
  userListRecommendedReducer,
  userProfileDetailReducer,
  userPostsListReducer,
  userArticleListReducer,
  followingReducer,
  followReducer,
} from "./userReducers";

import {
  postDashboardReducer,
  postSearchListReducer,
} from "../components/socialWall/reducers/postReducers";
import {
  articlePageReducer,
  createArticleReducer,
  articleSearchListReducer,
} from "../components/socialWall/reducers/articleReducer";
import {
  notificationsReducer,
  unreadNotificationsReducer,
} from "../components/socialWall/reducers/notificationsReducer";
import { searchBarReducer } from "../components/socialWall/reducers/searchBarReducer";

const rootReducer = (history) =>
  combineReducers({
    session,
    success,
    general,
    nav,
    adminList,
    lastCourseStateReducer,
    error,
    router: connectRouter(history),
    userProfile,
    callGetUserProfileDetail,
    courses,
    courseCategories,
    adminCourseDashboard,
    courseDetail,
    courseDiscussion,
    courseDiscussions,
    courseFAQsList,
    courseReviews,
    fileRepo,
    adminCourseModule,
    adminCourseFaq,
    threads,
    arCourses,
    vrCourses,
    mrCourses,
    organizationList,
    LocationList,
    usersdetails,
    assignUserList,
    PathList,
    learnerCourse,
    courseModule,
    learnerCourseReviews,
    learnerCourseReviewReducer,
    watchedVideos,
    notificationReducer,
    assignReducer,
    cateReducer,
    eventReducer,
    local,
    auth,
    searchBar: searchBarReducer,
    userList: userListReducer,
    following: followingReducer,
    follow: followReducer,
    userListRecommended: userListRecommendedReducer,
    userProfileDetail: userProfileDetailReducer,
    userPostsList: userPostsListReducer,
    createArticle: createArticleReducer,
    postSearchList: postSearchListReducer,
    articleSearchList: articleSearchListReducer,
    articlePage: articlePageReducer,
    dashboard: postDashboardReducer,
    userArticleList: userArticleListReducer,
    notifications: notificationsReducer,
    unreadNotifications: unreadNotificationsReducer,
    classrooms,
    topics,
    sessions,
    classroomDashboard,
    editClassroomSession,
    calendarDashBoard,
    additionalDashBoard,
    uuidThemeReducer,
    proctor,
    selectedAssessment,
    proctoringUsers,
  });

export const selectAllErrorsMapped = (state) =>
  errorSelector.selectAllErrorsMapped(state.error);

export default rootReducer;